/**
 * Rôles et droits fins (architecture, 5.1, 5.2 et 5.3).
 *
 * Trois portées, trois familles de rôles : la galerie, le groupe, la console
 * Artosera. Les droits fins sont accordés membre par membre, en plus du rôle.
 */
import { z } from 'zod';
/** Rôles par galerie (5.1). */
export const ROLES_GALERIE = ['direction', 'equipe', 'lecture', 'comptable'];
export const roleGalerieSchema = z.enum(ROLES_GALERIE);
/** Rôles de groupe (5.2). */
export const ROLES_GROUPE = ['direction_groupe', 'administration_groupe'];
export const roleGroupeSchema = z.enum(ROLES_GROUPE);
/**
 * Rôles de la console Artosera (5.3), du plus étroit au plus large.
 * `venio_associe` : associé de Venio (dirigeant, investisseur), qui suit
 * l'activité par la vue d'aigle et rien d'autre (ARTO-58).
 */
export const ROLES_CONSOLE = [
    'venio_associe',
    'venio_support',
    'venio_exploitation',
    'venio_direction',
];
export const roleConsoleSchema = z.enum(ROLES_CONSOLE);
/** Tous les rôles, toutes portées confondues. */
export const ROLES = [...ROLES_GALERIE, ...ROLES_GROUPE, ...ROLES_CONSOLE];
export const roleSchema = z.enum(ROLES);
/** Les trois portées d'un rattachement. */
export const PORTEES = ['galerie', 'groupe', 'console'];
export const porteeSchema = z.enum(PORTEES);
/** Droits fins par membre, indépendants du rôle (5.1). */
export const DROITS_FINS = [
    'voirPrixArtiste',
    'coffreConfidentiel',
    'emettreFactures',
    'publierSite',
];
export const droitsFinsSchema = z.object({
    voirPrixArtiste: z.boolean().default(false),
    coffreConfidentiel: z.boolean().default(false),
    emettreFactures: z.boolean().default(false),
    publierSite: z.boolean().default(false),
});
/** Aucun droit fin accordé. */
export const AUCUN_DROIT = {
    voirPrixArtiste: false,
    coffreConfidentiel: false,
    emettreFactures: false,
    publierSite: false,
};
/** La portée à laquelle appartient un rôle. */
export function porteeDuRole(role) {
    if (ROLES_GALERIE.includes(role))
        return 'galerie';
    if (ROLES_GROUPE.includes(role))
        return 'groupe';
    return 'console';
}
//# sourceMappingURL=roles.js.map